import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import NavBar from "components/landingPage/NavBar";
import LabelTitulos from "components/layout/labelTitulos";
import SelectTipoIdentificacion from "components/Inputs/SelectTipoIdentificacion";
import SelectCiudades from "components/Inputs/SelectCiudades";
import InputLabel from "components/Inputs/InputLabel";
import { validarString, TIPOS_DATOS } from "utils/ValidarDatos";
import ContratoModal from "components/landingPage/contratoModal";
import { validarPinTransaccion } from "network/Api/Transaccion";
import { registrarPersonaPin } from "network/Api/Transaccion";
import { registrarPersona } from "network/Api/Persona";
import ModalConfirmacion from "components/modal/ModalConfirmacion";
import { calcularDigitoVerificacion } from "utils/funcionesUtiles";
import "components/landingPage/css/creative.css";

const styles = (theme) => ({
  containerLogos: {
    flex: 1,
    display: "inline-flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "nowrap",
    maxHeight: "3em",
    maxWidth: "100%",
    margin: 0,
    padding: 0,
  },
  rootLogo: {
    display: "inline",
    justifyContent: "space-between",
    alignItems: "center",
    textAlign: "center",
    maxHeight: "inherit",
    maxWidth: "100%",
  },
  logo: {
    maxHeight: "inherit",
    maxWidth: "100%",
  },
  titulo: {
    fontFamily: "Aclonica",
    fontSize: "1.6rem",
  },
  subTitulo: {
    textAlign: "center",
  },
  root: {
    flexGrow: 2,
    maxWidth: "100%",
  },
  fontFamily: {
    whiteSpace: "nowrap",
    textAlign: "left",
  },
  show: {
    display: "block",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
});

const customStyles = {
  input: (styles) => {
    return {
      ...styles,
      height: "2.25rem",
    };
  },
};

const NuevoEmisor = ({ classes }) => {
  const [state, setData] = useState({
    modalProps: {
      open: false,
      content: "",
      onAccept: () => {},
    },
  });

  const setState = (data) => setData((d) => ({ ...d, ...data }));

  useEffect(() => {
    const url = new URLSearchParams(window.location.search);
    setState({
      aliado: url.get("fromRedirect"),
      tipoCompra: url.get("tipo") || "PIN",
    });
  }, []);

  useEffect(
    () =>
      setState({
        disabledName:
          state.cdTipoIdentificacion === "NIT" || !state.cdTipoIdentificacion,
      }),
    [state.cdTipoIdentificacion]
  );

  const handleChange = (event) =>
    setState({ [event.target.name]: event.target.value });

  const handleEnvio = async (event) => {
    event.preventDefault();
    setState({ loadingRegistro: true });
    const errores = await validarFormulario();
    setState({
      modalProps: {
        ...state.modalProps,
        open: true,
        content: errores ? errores : "¿Seguro desea registrarse?",
        onAccept: errores
          ? () => closeModalProps()
          : () => {
              registrarEmisor();
              closeModalProps();
            },
      },
    });
  };

  const registrarEmisor = () => {
    if (state.tipoCompra !== "PIN") guardarPersona();
    else guardarPersonaPin();
  };

  const guardarPersonaPin = () => {
    registrarPersonaPin({
      dsPin: state.dsPin,
      persona: {
        cdTipoIdentificacion: state.cdTipoIdentificacion,
        dsIdentificacion: `${
          state.dsIdentificacion
        }-${calcularDigitoVerificacion(state.dsIdentificacion)}`,
        dsNombre: state.dsNombre,
        dsSegundoNombre: state.dsSegundoNombre,
        dsPrimerApellido: state.dsPrimerApellido,
        dsSegundoApellido: state.dsSegundoApellido,
        dsTelefono: state.dsTelefono,
        dsCelular: state.dsCelular,
        dsDireccion: state.dsDireccion,
        ciudad: {
          nmId: state.nmIdCiudad,
        },
        dsNombreContacto: state.dsNombreContacto,
        dsTelefonoContacto: state.dsTelefono,
        dsEmail: state.dsEmail,
        dsTokenPrimrecar: JSON.stringify({
          idSolicitud: state.dsPin,
          codigoAliado: state.aliado,
        }),
        dsAliado: state.aliado,
        cdEstadoTransaccion: "A",
        dsDigitoVerificacion: calcularDigitoVerificacion(
          state.dsIdentificacion
        ),
      },
    }).then((res) => {
      if (res.status === 200)
        setState({
          modalProps: {
            ...state.modalProps,
            open: true,
            content: "Registrado Exitosamente",
            onAccept: () =>
              (window.location.href = "http://www.portalfactura.com/"),
            onCancel: () =>
              (window.location.href = "http://www.portalfactura.com/"),
          },
        });
    });
  };

  const guardarPersona = () => {
    const bodyPersona = getBodyRegistroPersona();
    registrarPersona(bodyPersona).then((responsePersona) => {
      if (responsePersona.status === 200)
        setState({
          modalProps: {
            ...state.modalProps,
            open: true,
            content: "Registrado Exitosamente",
            onAccept: () =>
              (window.location.href = "http://www.portalfactura.com/"),
            onCancel: () =>
              (window.location.href = "http://www.portalfactura.com/"),
          },
        });
    });
  };

  const getBodyRegistroPersona = (response = {}) => {
    return {
      cdTipoIdentificacion: state.cdTipoIdentificacion,
      dsIdentificacion: `${state.dsIdentificacion}-${calcularDigitoVerificacion(
        state.dsIdentificacion
      )}`,
      dsNombre: state.dsNombre,
      dsSegundoNombre: state.dsSegundoNombre,
      dsPrimerApellido: state.dsPrimerApellido,
      dsSegundoApellido: state.dsSegundoApellido,
      dsTelefono: state.dsTelefono,
      dsCelular: state.dsCelular,
      dsDireccion: state.dsDireccion,
      ciudad: {
        nmId: state.nmIdCiudad,
      },
      dsNombreContacto: state.dsNombreContacto,
      dsTelefonoContacto: state.dsTelefono,
      dsEmail: state.dsEmail,
      dsTokenPrimrecar: JSON.stringify({}),
      dsAliado: state.aliado,
      cdEstadoTransaccion: "P",
      dsDigitoVerificacion: calcularDigitoVerificacion(state.dsIdentificacion),
    };
  };

  const validarFormulario = async () => {
    const {
      cdTipoIdentificacion,
      dsIdentificacion,
      dsNombre,
      dsPrimerApellido,
      dsTelefono,
      dsCelular,
      dsDireccion,
      nmIdCiudad,
      dsNombreContacto,
      dsEmail,
      dsPin,
    } = state;
    const errorResponse =
      "Faltan campos por llenar. Por favor tenga en cuenta que todos los campos son obligatorios";
    if (!cdTipoIdentificacion) return errorResponse;
    if (!dsIdentificacion) return errorResponse;
    if (!dsNombre) return errorResponse;
    if (!dsPrimerApellido && "NIT" !== cdTipoIdentificacion)
      return errorResponse;
    if (!dsTelefono) return errorResponse;
    if (!dsCelular) return errorResponse;
    if (!dsDireccion) return errorResponse;
    if (!nmIdCiudad) return errorResponse;
    if (!dsNombreContacto) return errorResponse;
    if (!validarString(dsEmail, TIPOS_DATOS.email)) return errorResponse;
    if (state.tipoCompra === "PIN") {
      const statePin = await validarPinTransaccion({ dsPin });
      if (dsPin && statePin.data !== "VIGENTE")
        return "PIN Invalido o ya no se encuentra vigente";
    }
  };

  const closeModalProps = () =>
    setState({
      modalProps: { ...state.modalProps, open: false },
      loadingRegistro: false,
    });

  return (
    <div>
      <NavBar />
      <header className="masthead-nuevo-emisor mt-0">
        <div className="container h-100 mt-0">
          <LabelTitulos
            className={classes.titulo}
            texto="Registrarse en portal factura"
          />
          <p className={`${classes.subTitulo} text-muted mb-3`}>
            Ingresa los datos a continuación para obtener un nuevo usuario de
            portal factura
          </p>
          <div className="form-row col-md-12 d-flex justify-content-between">
            <div className="form-group col-md-12 col-xl-4 mb-3">
              <SelectTipoIdentificacion
                onChange={(e) => setState({ cdTipoIdentificacion: e.value })}
                placeholder="Tipo identificación*"
                styles={customStyles}
              />
            </div>
            <div className="form-group col-md-12 col-xl-2 mb-0">
              <InputLabel
                maxLength="35"
                name="dsIdentificacion"
                id="dsIdentificacion"
                value={state.dsIdentificacion || ""}
                label="# identificación *"
                labelClassName={classes.fontFamily}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-12 col-xl-2 mb-0">
              <InputLabel
                maxLength="1"
                name="dsDigitoVerificacion"
                id="dsDigitoVerificacion"
                value={calcularDigitoVerificacion(state.dsIdentificacion || "")}
                label="Dígito verifi."
                labelClassName={classes.fontFamily}
                onChange={handleChange}
                disabled={true}
              />
            </div>
            <div className="form-group col-md-12 col-xl-4 mb-0">
              <InputLabel
                maxLength="200"
                name="dsNombre"
                id="dsNombre"
                value={state.dsNombre || ""}
                label="Nombre o razón social *"
                labelClassName={classes.fontFamily}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="form-row col-md-12 d-flex justify-content-between">
            <div className="form-group col-md-12 col-xl-4 mb-0">
              <InputLabel
                maxLength="200"
                name="dsSegundoNombre"
                id="dsSegundoNombre"
                value={state.dsSegundoNombre || ""}
                label="Segundo nombre"
                labelClassName={classes.fontFamily}
                onChange={handleChange}
                disabled={state.disabledName}
              />
            </div>
            <div className="form-group col-md-12 col-xl-4 mb-0">
              <InputLabel
                maxLength="200"
                name="dsPrimerApellido"
                id="dsPrimerApellido"
                value={state.dsPrimerApellido || ""}
                label="Primer apellido"
                labelClassName={classes.fontFamily}
                onChange={handleChange}
                disabled={state.disabledName}
              />
            </div>
            <div className="form-group col-md-12 col-xl-4 mb-0">
              <InputLabel
                maxLength="200"
                name="dsSegundoApellido"
                id="dsSegundoApellido"
                value={state.dsSegundoApellido || ""}
                label="Segundo apellido"
                labelClassName={classes.fontFamily}
                onChange={handleChange}
                disabled={state.disabledName}
              />
            </div>
          </div>
          <div className="form-row col-md-12 d-flex justify-content-between">
            <div className="form-group col-md-12 col-xl-4 mb-0">
              <InputLabel
                maxLength="100"
                name="dsTelefono"
                id="dsTelefono"
                value={state.dsTelefono || ""}
                label="Teléfono *"
                labelClassName={classes.fontFamily}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-12 col-xl-4 mb-0">
              <InputLabel
                maxLength="100"
                name="dsCelular"
                id="dsCelular"
                value={state.dsCelular || ""}
                label="Celular *"
                labelClassName={classes.fontFamily}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-12 col-xl-4 mb-0">
              <InputLabel
                maxLength="255"
                name="dsDireccion"
                id="dsDireccion"
                value={state.dsDireccion || ""}
                label="Dirección *"
                labelClassName={classes.fontFamily}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="form-row col-md-12 d-flex justify-content-between">
            <div className="orm-group col-md-12 col-xl-4 mb-3">
              <SelectCiudades
                onChange={(e) => setState({ nmIdCiudad: e.value })}
                placeholder="Ciudad *"
                styles={customStyles}
              />
            </div>
            <div className="form-group col-md-12 col-xl-4 mb-3">
              <InputLabel
                maxLength="100"
                name="dsNombreContacto"
                id="dsNombreContacto"
                value={state.dsNombreContacto || ""}
                label="Nombre contacto *"
                labelClassName={classes.fontFamily}
                onChange={handleChange}
              />
            </div>

            <div className="form-group col-md-12 col-xl-4 mb-3">
              <InputLabel
                maxLength="100"
                name="dsEmail"
                id="dsEmail"
                value={state.dsEmail || ""}
                label="E-Mail de contacto *"
                labelClassName={classes.fontFamily}
                onChange={handleChange}
              />
            </div>
          </div>
          {state.tipoCompra === "PIN" && (
            <div className="form-row col-md-12 d-flex justify-content-between">
              <div className="form-group col-md-12 col-xl-6 mb-3">
                <InputLabel
                  maxLength="100"
                  name="dsPin"
                  id="dsPin"
                  value={state.dsPin || ""}
                  label="PIN"
                  labelClassName={classes.fontFamily}
                  onChange={handleChange}
                />
                <div className="form-group col-md-12 col-xl-12 mb-12">
                  <small className="text-muted">
                    Dando clic en "Registrarse", aceptas nuestros{" "}
                    <b
                      onClick={() => setState({ openContrato: true })}
                      className="text-contrato"
                    >
                      terminos y condiciones.
                    </b>
                  </small>
                </div>
              </div>
            </div>
          )}
          <div className="form-row col-md-12 d-flex justify-content-end">
            <div className="form-group col-md-12 col-xl-4 mb-5">
              <button
                className="btn btn-lg btn-primary btn-block text-uppercase"
                disabled={state.loadingRegistro}
                onClick={handleEnvio}
              >
                {state.loadingRegistro && (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  />
                )}
                REGISTRARSE
              </button>
            </div>
          </div>
        </div>
      </header>
      <ContratoModal
        openAccion={state.openContrato || false}
        handleCloseModal={() => setState({ openContrato: false })}
      />
      <ModalConfirmacion
        open={state.modalProps.open}
        content={state.modalProps.content}
        onAccept={state.modalProps.onAccept}
        onCancel={() => closeModalProps()}
      />
    </div>
  );
};

export default withStyles(styles)(NuevoEmisor);
